module.exports = __webpack_public_path__ + "assets/bd8e3631306e18136e59a883ae44aed0.jpg";